import React from "react";
import { BsInstagram } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import Container from "./styled";

// Footer reducido para las landings de alianzas (diseño de Marketing, nov-2026):
// contacto, redes, sellos y copyright. Sin links de navegación.
export default function FooterSimple() {
  return (
    <Container>
      <div className="footer-contenido">
        <img
          className="edificios"
          src="/images/footer/edificios-borde.svg"
          alt=""
          aria-hidden="true"
        />

        <div className="fila fila-contacto">
          <img className="logo" alt="Logo de SeguroBici" src="/images/logos/segurobici.svg" />
          <div className="contacto">
            <a href="tel:08102202373">0810-220-2373</a>
            <a href="mailto:info@segurobici.com.ar">info@segurobici.com.ar</a>
            <span>Suipacha 245 1° Piso CABA</span>
          </div>
        </div>

        <div className="fila fila-sellos">
          <div className="redes">
            <a
              href="https://es-la.facebook.com/SeguroBici/"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook de SeguroBici"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/segurobici/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram de SeguroBici"
            >
              <BsInstagram />
            </a>
          </div>
          <div className="sellos-bloque">
            <div className="sellos">
              <img
                className="sello-encrypt"
                alt="Logo de Let's Encrypt"
                src="/images/logos/otros/letsencrypt.png"
              />
              <a
                href="https://www.gyssrl.com.ar/webroot/footer/certificadoapt.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <img className="sello-ssn" alt="Logo SSN" src="/images/logos/otros/ssn.png" />
              </a>
              <a
                href="https://www.argentina.gob.ar/aaip/datospersonales"
                target="_blank"
                rel="noreferrer"
              >
                <img className="sello-pdp" alt="Logo PDP" src="/images/logos/otros/pdp.png" />
              </a>
              <a
                href="https://servicios1.afip.gov.ar/clavefiscal/qr/response.aspx?qr=vfDql9TuSM09b_FRxAacFg,,"
                target="_F960AFIPInfo"
              >
                <img
                  className="sello-fiscal"
                  alt="Logo de Data Fiscal"
                  src="/images/logos/otros/datafiscal.webp"
                />
              </a>
            </div>
            <p className="dato-ssn">
              N° de inscripción SSN: 0387 <span>|</span> Dept. de orientación y asistencia al
              asegurado <span>|</span>{" "}
              <a
                href="https://www.argentina.gob.ar/superintendencia-de-seguros"
                target="_blank"
                rel="noreferrer"
              >
                www.argentina.gob.ar/ssn
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="copyright">
        <p>
          © Copyright {new Date().getFullYear()} SeguroBici <span>|</span> Todos los derechos
          reservados <span>|</span> SeguroBici es una marca registrada de Gestión y Servicios S.R.L.
        </p>
        <nav>
          <a href="https://seguroweb.com.ar/arrepentimiento" target="_blank" rel="noreferrer">
            Botón de arrepentimiento
          </a>
          <a href="https://seguroweb.com.ar/baja" target="_blank" rel="noreferrer">
            Botón de baja
          </a>
        </nav>
      </div>
    </Container>
  );
}
